module.exports = __webpack_public_path__ + "img/OXE - JDO 998x1810 V2.a39f6dda.png";